import { toWSDateString } from "@wingspanhq/fe-component-library";
import type { resourceEventHistoryApiSpec } from "@wingspanhq/wingspan-api-types";

type AttributeValue = string | number | boolean | string[] | Date;

const formatters: Record<
  resourceEventHistoryApiSpec.WsDataTypes,
  (value: AttributeValue) => string
> = {
  String: value => String(value),
  Number: value => String(value),
  Boolean: value => (value ? "Yes" : "No"),
  Datetime: value => toWSDateString(value, "monthDayYear"),
  ValueSet: value => (Array.isArray(value) ? value.join(", ") : String(value))
};

export const formatAttributeValue = (
  value: unknown,
  type: resourceEventHistoryApiSpec.WsDataTypes
): string => formatters[type](value as AttributeValue);
